import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchRecommendations(options = {}) {
  const { page = 1, object, ...others } = options
  const params = {
    page,
    ...others
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchRecommendations',
    () => source.cancel('fetchRecommendations: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `recommendations/${object}`,
      method: 'get',
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => {
      const pagination = _.get(data, _.camelCase(`${object}_pagination`))
      return {
        ..._.pick(data, [_.camelCase(object)]),
        pagination,
        next: _.get(pagination, 'nextPage') > page
          ? () =>
            fetchRecommendations({
              ...options,
              page: page + 1,
            })
          : null,
      }
    })
}
